
import React from "react";
import { Navigate } from "react-router-dom";
// import unauthorized from "./components/Unathorized";
const ProtectedRoute = ({ allowedRoles, children }) => {
    const user = JSON.parse(localStorage.getItem("user"));
    console.log(user)
    if (!user || !allowedRoles.includes(user.role)) {
      return <Navigate to="/unauthorized" />;
    }
  
    return children;
  };

export default ProtectedRoute;
